import request from "../plugins/axios";


export function getLiveRoomGetQgList(params) {
	return request({
		url: '/scrm/liveRoomGetQgList',
		method: 'GET',
		params
	})
}
export function liveRoomCreateCourseSharingLink(params) {
	return request({
		url: '/scrm/liveRoomCreateCourseSharingLink',
		method: 'GET',
		params
	})
}
export function liveRoomGetHistoricalQgList(data) {
	return request({
		url: '/scrm/liveRoomGetHistoricalQgList',
		method: 'POST',
		data
	})
}
export function liveRoomGetUserViewist(data) {
	return request({
		url: '/scrm/liveRoomGetUserViewist',
		method: 'POST',
		data
	})
}

export function resendRedPacket(data) {
	return request({
		url: '/scrm/resendRedPacket',
		method: 'POST',
		data
	})
}

export function qunView(data) {
	return request({
		url: '/scrm/qunView',
		method: 'POST',
		data
	})
}

export function reissueRed(data) {
	return request({
		url: '/scrm/reissueRed',
		method: 'POST',
		data
	})
}
export function tenantLiveTrainList(data) {
	return request({
		url: '/scrm/tenantLiveTrainList',
		method: 'POST',
		data
	})
}